import React, {useState } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { makeStyles } from "@mui/styles";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "components/common/Modal";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import {Backdrop,FormControl,InputLabel,MenuItem,Select} from "@mui/material";
import Text from "components/common/Text";
import TextField from "components/common/TextField";

const useStyles = makeStyles((theme) => ({
  heading: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #ddd",
    paddingBottom: "16px",
  },
  headingcontent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: "16px",
  },
  content: {
    padding: "16px 0",
  },
  chargingPoint: {
    border: "1px solid #ddd",
    borderRadius: "8px",
    marginBottom: "16px",
    padding: "16px",
  },
  connectorList: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    "&::-webkit-scrollbar": {
      color: "white",
    },
  },
  connectorList2: {
    height: "150px",
    display: "flex",
    overflowY: "hidden",
    "&::-webkit-scrollbar": {
      color: "white",
    },
  },
  connector: {
    padding: "5px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    Width: "300px",
    margin: "5px",
  },
  connectortop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: "bold",
    width: "200px",
  },
  addButton: {
    display: "flex",
    justifyContent: "center",
    marginTop: "16px",
    width: "100%",
    border: "1px dashed ",
  },
  addButtonconnector: {
    width: "100%",
  },
  capacity: {
    fontSize: "14px",
  },
}));

const ModelChargingPoint = ({
  dropdowndata,
  handleClose,
  open,
  ChargingPointData,
  handleSubmitConnector,
  handleDeleteConnector,
  handleSubmitAddChPoint,
  handleSubmitEditConnector,
  handleSubmitEditChPoint,
  stationid,
}) => {

  const classes = useStyles();
  const [chargingpointid, setChargingPointID] = useState("");
  const [modalName, setModalName] = useState("View");
  const [connectoreditopenid, setConntorEditOpenId] = useState("");

  const [connectorErrors, setConnectorErrors] = useState({});

  const [formData, setFormData] = useState({
    charge_point_id: "",
    charger_type_id: "",
    power: "",
    price_per_khw: "",
  });
  const [pointformData, setPointFormData] = useState({
    name: "",
    station_id: stationid,
    cp_id: "",
    connectors: [{ charger_type_id: "", power: "", price_per_khw: "" }],
  });

  
  const [pointupdate, setPointUpdate] = useState({
    name: "",
    cp_id: "",
    station_id: "",
    id: "",
  });
  const [connectorupdate, setConnectorUpdate] = useState({
    id: "",
    charger_type_id: "",
    price_per_khw: "",
    power: "",
    pointName: "",
    connectorName: "",
  });

  const pointhandleChange = (prop) => (event) => {
    setPointFormData({ ...pointformData, [prop]: event.target.value });
  };

  const pointhandleChangeConnecter = (connectorIndex, prop) => (event) => {
    const updatedConnectors = [...pointformData.connectors];
    updatedConnectors[connectorIndex][prop] = event.target.value;
    setPointFormData({ ...pointformData, connectors: updatedConnectors });
  };

  const handleChange = (prop) => (event) => {
    setFormData({ ...formData, [prop]: event.target.value });
  };

  const pointUpdatehandleChange = (prop) => (event) => {
    setPointUpdate({ ...pointupdate, [prop]: event.target.value });
  };
  const ConnectorUpdatehandleChange = (prop) => (event) => {
  
    setConnectorUpdate({ ...connectorupdate, [prop]: event.target.value });
  };

  const handleUpdatePintEdit = () => {
    handleSubmitEditChPoint(pointupdate, stationid, chargingpointid);
    setModalName("View");
  };
  const handleConnectorUpdateEdit = () => {
    handleSubmitEditConnector(
      connectorupdate,
      chargingpointid,
      connectoreditopenid
    );
    setModalName("View");
  };

  const validateConnectorErrorsForm = () => {
    const newConnectorErrors = {};
    pointformData.connectors.forEach((connector, index) => {
      if (!connector.charger_type_id) {
        newConnectorErrors[`charger_type_id_${index}`] = "Charging Connector is required";
      }
      if (!connector.power) {
        newConnectorErrors[`power_${index}`] = "Power (Kw) is required";
      }
      if (!connector.price_per_khw) {
        newConnectorErrors[`price_per_khw_${index}`] = "Rate is required";
      }
    });
  
    setConnectorErrors(newConnectorErrors);
    return Object.keys(newConnectorErrors).length === 0; 
  };

  const pointhandleAddConnector = () => {
    if (validateConnectorErrorsForm()) {
      handleSubmitAddChPoint(pointformData, stationid); 
      setPointFormData({
        name: "",
        station_id: stationid,
        cp_id: "",
        connectors: [{ charger_type_id: "", power: "", price_per_khw: "" }]
      });
      setModalName("View");
    }
  };
  
  const handleUpdatepoint = (Id, name) => {
    setModalName("edit");

    setPointUpdate({
      name: name,
      cp_id: Id,
      station_id: stationid,
      id: Id,
    });
  };

  const handleConnector = (Id) => {
    setChargingPointID(Id);

    setModalName("connector");
  };
  const handleAddConnector = () => {
    handleSubmitConnector(formData, chargingpointid);
    setModalName("View");
    setFormData({
      charge_point_id: "",
      charger_type_id: "",
      power: "",
      price_per_khw: "",
      cp_id: "",
      name: "",
    });
  };
  const handleSetConnector = (
    id,
    cc,
    cr,
    pointName,
    connectorName,
    charger_type_id
  ) => {
 
    setConntorEditOpenId(id);
    setModalName("editconnectorpoint");
    setConnectorUpdate({
      id: id,
      charger_type_id: charger_type_id,
      price_per_khw: cc,
      power: cr,
      pointName: pointName,
      connectorName: connectorName,
    });
  };
  const addConnectors = () => {
    setPointFormData({
      ...pointformData,
      connectors: [
        ...pointformData.connectors,
        { charger_type_id: "", power: "", price_per_khw: "", name:"", cp_id:''  },
      ],
    });
  };
  const removeConnectorbyid = (id) => {
   
    if (pointformData.connectors.length > 1) {
      setPointFormData((prevState) => ({
        ...prevState,
        connectors: prevState.connectors.filter((_, i) => i !== id),
      }));
    }
  };


  if (modalName !== "View") if (!open) setModalName("View");
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      size="md"
      BackdropComponent={Backdrop}
    >
      {modalName === "View" && (
        <>
          <Box className={classes.modalBox}>
            <Box className={classes.heading}>
              <Typography variant="h6">Add Charging Points</Typography>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
            {ChargingPointData.length > 0 ? (
              <Box className={classes.content}>
                {ChargingPointData?.map((point) => (
                  <Box key={point.id} className={classes.chargingPoint}>
                    <Box className={classes.headingcontent}>
                      <Typography variant="subtitle1">{point.name}</Typography>
                      <span>
                        <IconButton
                          size="small"
                          onClick={() =>
                            handleUpdatepoint(point.id, point.name)
                          }
                        >
                          <EditOutlinedIcon sx={{color:'green',fontSize:'22px'}}/>
                        </IconButton>
                      </span>
                    </Box>
                    {point.connecters.length >0 &&
                    <Box className={classes.connectorList}>
                      <Box className={classes.connectorList2}>
                        {point.connecters.map((connector, index) => (
                          <Box key={index} className={classes.connector}>
                            <Typography
                              className={classes.connectortop}
                              variant="body2"
                            >
                              <img
                                src="../images/Group 67505.png"
                                alt="logo"
                                style={{ width: "20px", marginRight: "5px" }}
                              />
                              {connector.name}
                              <Box>
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    handleDeleteConnector(connector.id)
                                  }
                                >
                                  <DeleteOutlineOutlinedIcon sx={{color:'red',fontSize:"22px"}} />
                                </IconButton>
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    handleSetConnector(
                                      connector.id,
                                      connector.capacity,
                                      connector.rate,
                                      point.name,
                                      connector.name,
                                      connector.charger_type_id
                                    )
                                  }
                                >
                                    <EditOutlinedIcon sx={{color:'green',fontSize:'22px'}}/>
                                </IconButton>
                              </Box>
                            </Typography>
                            <Typography
                              className={classes.capacity}
                              variant="body2"
                            >
                              Capacity: {connector.capacity}
                              <br />
                              Rate: ₹{connector.rate} per Kw
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                    }
                    <Button
                      variant="outlined"
                      startIcon={<AddIcon />}
                      onClick={() => handleConnector(point.id)}
                      className={classes.addButton}
                      sx={{
                        fontSize: { md: "16px", xs: "14px" },
                      }}
                    >
                      Add charging connector
                    </Button>
                  </Box>
                ))}

                <Box
                  sx={{
                    position: "absolute",
                    bottom: "10px",
                    right: "10px",

                    width: "40px",
                    height: "40px",
                    background: "#19AA69",
                    borderRadius: "50%",
                    float: "right",
                    textAlign: "center",
                    color: "#ffff",
                    fontSize: "25px",
                    marginRight: "20px",
                    cursor: "pointer",
                  }}
                  onClick={() => setModalName("addconnectorpoint")}
                >
                  +
                </Box>
              </Box>
            ) : (
              <Box
                sx={{
                  textAlign: "center",
                  marginTop: "20%",
                }}
                onClick={() => setModalName("addconnectorpoint")}
              >
                Data Not Found !
              </Box>
            )}
          </Box>
          <Box
            sx={{
              position: "absolute",
              bottom: "10px",
              right: "10px",

              width: "40px",
              height: "40px",
              background: "#19AA69",
              borderRadius: "50%",
              float: "right",
              textAlign: "center",
              color: "#ffff",
              fontSize: "25px",
              marginRight: "20px",
              cursor: "pointer",
            }}
            onClick={() => setModalName("addconnectorpoint")}
          >
            +
          </Box>
        </>
      )}
      {modalName === "edit" && (
        <Box className={classes.modalBox}>
          <Box className={classes.heading}>
            <Typography variant="h6">Point</Typography>
            <IconButton onClick={() => setModalName("View")}>
              <CloseIcon />
            </IconButton>
          </Box>

          <div>
            <Box sx={{ mt: 3 }}>
              <InputLabel>Enter charging point name</InputLabel>
              <FormControl fullWidth sx={{ marginBottom: "20px" }}>
                <TextField
                  fullWidth
                  size="small"
                  value={pointupdate.name}
                  onChange={pointUpdatehandleChange("name")}
                  onInput={(e) => {
                    const value = e.target.value.replace(/\s+/g, "");
                    e.target.value = value;
                  }}
                  sx={{ marginBottom: "20px" }}
                />
              </FormControl>
            </Box>
            <Button
              disabled={!pointupdate.name}
              onClick={() => handleUpdatePintEdit()}
              variant="contained"
            >
              Update
            </Button>
          </div>
        </Box>
      )}
      {modalName === "connector" && (
        <Box className={classes.modalBox}>
          <Box className={classes.heading}>
            <Typography variant="h6">Add Charging connector</Typography>
            <IconButton>
              <CloseIcon onClick={() => setModalName("View")} />
            </IconButton>
          </Box>

          <Box mt={2}>
            <InputLabel>Charging connector</InputLabel>

            <FormControl fullWidth sx={{ marginBottom: "20px" }} size="small">
              <Select
                name="charging_connector"
                value={formData.charger_type_id}
                onChange={handleChange("charger_type_id")}
              >
                {dropdowndata?.chargerTypes
                  ?.filter((item) => item && item.name) 
                  ?.sort((a, b) => a.name.localeCompare(b.name))
                  ?.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>

            <InputLabel sx={{fontSize:'14px'}}>Power(kw)</InputLabel>
            <FormControl fullWidth sx={{ marginBottom: "10px" }}>
              <TextField
                fullWidth
                // type="number"
                value={formData.power}
                onChange={handleChange("power")}
                sx={{ marginBottom: "10px" }}
                size="small"
                inputProps={{
                  pattern: "[0-9]*([.,][0-9]*)?", 
                  title: "Only numbers and decimal points are allowed",
                }}
                onInput={(e) => {
                  const value = e.target.value
                    .replace(/^\s+/, "") 
                    .replace(/[^0-9.,]/g, "") 
                    .replace(/(\..*?)\..*/g, "$1"); 
                  e.target.value = value;
                }}
              />
            </FormControl>

            <InputLabel>Rate(₹)</InputLabel>
            <FormControl fullWidth sx={{ marginBottom: "20px" }}>
              <TextField
                fullWidth
                value={formData.price_per_khw}
                onChange={handleChange("price_per_khw")}
                sx={{ marginBottom: "20px" }}
                size="small"
                inputProps={{
                  pattern: "[0-9]*([.,][0-9]*)?", 
                  title: "Only numbers and decimal points are allowed",
                }}
                onInput={(e) => {
                  const value = e.target.value
                    .replace(/^\s+/, "") 
                    .replace(/[^0-9.,]/g, "") 
                    .replace(/(\..*?)\..*/g, "$1"); 
                  e.target.value = value;
                }}
              />
            </FormControl>
          </Box>

          <Button
            disabled={
              !formData.price_per_khw ||
              !formData.power ||
              !formData.charger_type_id
            }
            variant="contained"
            onClick={() => handleAddConnector()}
          >
            Add Connector
          </Button>
        </Box>
      )}
      {modalName === "addconnectorpoint" && (
        <Box className={classes.modalBox}>
          <Box className={classes.heading}>
            <Typography variant="h6"> Add Charging Point</Typography>
            <IconButton>
              <CloseIcon onClick={() => setModalName("View")} />
            </IconButton>
          </Box>

          <Box mt={1}>
            <InputLabel sx={{fontSize:'14px'}}>Charging point name</InputLabel>
            <FormControl fullWidth sx={{ marginBottom: "10px" }}>
              <TextField
                fullWidth
                size="small"
                value={pointformData.name}
                onChange={pointhandleChange("name")}
                sx={{ marginBottom: "10px" }}
              />
            </FormControl>
            <InputLabel sx={{fontSize:'14px'}}>Charging point ID</InputLabel>
            <FormControl fullWidth sx={{ marginBottom: "10px" }}>
              <TextField
                fullWidth
                size="small"
                inputProps={{
                  pattern: "[0-9]*([.,][0-9]*)?", 
                  title: "Only numbers and decimal points are allowed",
                }}
                value={pointformData.cp_id}
                onChange={pointhandleChange("cp_id")}
                onInput={(e) => {
                  const value = e.target.value
                    .replace(/^\s+/, "") 
                    .replace(/[^0-9.,]/g, "") 
                    .replace(/(\..*?)\..*/g, "$1"); 
                  e.target.value = value;
                }}
                sx={{ marginBottom: "20px", width: "100%" }}
              />
            </FormControl>

            <Box>
              {pointformData?.connectors.map((connector, index) => (
                <Box key={index}>
                  <Box
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Text>Charging Connector {connector.id}</Text>
                    <IconButton onClick={() => removeConnectorbyid(index)}>
                      <CloseIcon />
                    </IconButton>
                  </Box>
               <InputLabel sx={{ fontSize: '14px' }}>Charging Connector</InputLabel>
                  <FormControl
                    fullWidth
                    sx={{ marginBottom: "20px" }}
                    size="small"
                  >
                    <Select
                      name="charger_type_id"
                      value={connector.charger_type_id || ""}
                      onChange={pointhandleChangeConnecter(
                        index,
                        "charger_type_id"
                      )}
                    >
                      {dropdowndata?.chargerTypes
                        ?.filter((item) => item && item.name) 
                        ?.sort((a, b) => a.name.localeCompare(b.name))
                        ?.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        ))}
                    </Select>
                  {connectorErrors[`charger_type_id_${index}`] && (
                    <Text sx={{ color: "red",fontSize:'12px' }}>{connectorErrors[`charger_type_id_${index}`]}</Text>
                  )}
                </FormControl>

                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexDirection: "column",
                      }}
                    >
                      <Text sx={{fontSize:'14px'}}>Power(Kw)</Text>
                      <TextField
                        fullWidth
                        size="small"
                        inputProps={{
                          pattern: "[0-9]*([.,][0-9]*)?", 
                          title: "Only numbers and decimal points are allowed",
                        }}
                        value={connector.power || ""}
                        onChange={pointhandleChangeConnecter(index, "power")}
                        onInput={(e) => {
                          const value = e.target.value
                            .replace(/^\s+/, "") 
                            .replace(/[^0-9.,]/g, "") 
                            .replace(/(\..*?)\..*/g, "$1");
                          e.target.value = value;
                        }}
                        sx={{ marginBottom: "20px", width: "100%" }}
                      />
                        {connectorErrors[`power_${index}`] && (
                          <Text sx={{ color: "red",fontSize:'12px' }}>{connectorErrors[`power_${index}`]}</Text>
                        )}
                    </Box>

                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        flexDirection: "column",
                      }}
                    >
                      <Text sx={{fontSize:'14px'}}>Rate</Text>
                      <TextField
                        fullWidth
                        size="small"
                        inputProps={{
                          pattern: "[0-9]*([.,][0-9]*)?",
                          title: "Only numbers and decimal points are allowed",
                        }}
                        value={connector.price_per_khw || ""}
                        onChange={pointhandleChangeConnecter(
                          index,
                          "price_per_khw"
                        )}
                        onInput={(e) => {
                          const value = e.target.value
                            .replace(/^\s+/, "") 
                            .replace(/[^0-9.,]/g, "") 
                            .replace(/(\..*?)\..*/g, "$1"); 
                          e.target.value = value;
                        }}
                        sx={{ marginBottom: "20px", width: "100%" }}
                      />
                        {connectorErrors[`price_per_khw_${index}`] && (
                          <Text sx={{ color: "red",fontSize:'12px' }}>{connectorErrors[`price_per_khw_${index}`]}</Text>
                        )}
                    </Box>
                  </Box>
                </Box>
              ))}

              <Button
                style={{ width: "100%" }}
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={() => addConnectors()}
                classes="addButtonconnector"
              >
                Add charging connector
              </Button>
            </Box>
          </Box>
          {modalName === "addconnectorpoint" && (
            <Button
              sx={{ margin: "10px 0px" }}
              variant="contained"
              onClick={() => pointhandleAddConnector()}
            >
              Submit
            </Button>
          )}
        </Box>
      )}

      {modalName === "editconnectorpoint" && (
        <Box className={classes.modalBox}>
          <Box className={classes.modalBox}>
            <Box className={classes.heading}>
              <Typography variant="h6">{`${connectorupdate.pointName} (${connectorupdate.connectorName})`}</Typography>
              <IconButton onClick={() => setModalName("View")}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Box mt={1}>
              <InputLabel sx={{fontSize:'14px'}}>Charging connector</InputLabel>
              <FormControl fullWidth sx={{ marginBottom: "10px" }} size="small">
                <Select
                  name="charging_connector"
                  value={
                    connectorupdate?.charger_type_id ?? connectoreditopenid
                  }
                  onChange={ConnectorUpdatehandleChange("charger_type_id")}
                >
                  {dropdowndata?.chargerTypes
                    ?.filter((item) => item && item.name)
                    ?.sort((a, b) => a.name.localeCompare(b.name))
                    ?.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>

              <InputLabel sx={{fontSize:'14px'}}>Power (kw)</InputLabel>
              <FormControl fullWidth sx={{ marginBottom: "10px" }}>
                <TextField
                  fullWidth
                  size="small"
                  inputProps={{
                    pattern: "[0-9]*([.,][0-9]*)?",
                    title: "Only numbers and decimal points are allowed",
                  }}
                  value={connectorupdate?.power}
                  onChange={ConnectorUpdatehandleChange("power")}
                  onInput={(e) => {
                    const value = e.target.value
                      .replace(/^\s+/, "") 
                      .replace(/[^0-9.,]/g, "") 
                      .replace(/(\..*?)\..*/g, "$1"); 
                    e.target.value = value;
                  }}
                  sx={{ marginBottom: "10px" }}
                />
              </FormControl>

              <InputLabel sx={{fontSize:'14px'}}>Rate ($)</InputLabel>
              <FormControl fullWidth sx={{ marginBottom: "10px" }}>
                <TextField
                  fullWidth
                  size="small"
                  inputProps={{
                    pattern: "[0-9]*([.,][0-9]*)?",
                    title: "Only numbers and decimal points are allowed",
                  }}
                  value={connectorupdate?.price_per_khw}
                  onChange={ConnectorUpdatehandleChange("price_per_khw")}
                  onInput={(e) => {
                    const value = e.target.value
                      .replace(/^\s+/, "") 
                      .replace(/[^0-9.,]/g, "") 
                      .replace(/(\..*?)\..*/g, "$1"); 
                    e.target.value = value;
                  }}
                  sx={{ marginBottom: "10px" }}
                />
              </FormControl>
            </Box>
          </Box>
          <Button
            disabled={
              !connectorupdate?.price_per_khw ||
              !connectorupdate?.power ||
              !connectorupdate?.charger_type_id
            }
            variant="contained"
            onClick={() => handleConnectorUpdateEdit()}
          >
            Update
          </Button>
        </Box>
      )}
    </Modal>
  );
};

export default ModelChargingPoint;
